import { useEffect } from "react";

/**
 * Sets document.title and the meta description on mount.
 * Restores previous values on unmount so navigating back stays clean.
 */
export function usePageMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    if (title) document.title = title;
    if (description) {
      if (meta) meta.setAttribute("content", description);
      else {
        const m = document.createElement("meta");
        m.setAttribute("name", "description");
        m.setAttribute("content", description);
        document.head.appendChild(m);
      }
    }
    return () => {
      document.title = prevTitle;
      if (meta && prevDesc != null) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
